module.exports = __webpack_public_path__ + "eb881c5b2123d3904951feb85b6a540e.svg";